// import { export_json_to_excel } from "../utils/excal/Export2Excel.js";
import { setLocalStorage, getLocalStorage } from "../utils/storage";
import { ticketer_order_detail } from "../api/order"

export const proApiUrl = 'https://sk-m.api.fxzb.vip';
// export const proApiUrl = 'https://dev.sk-m.api.fxzb.vip';
// export const proApiUrl = 'http://192.168.110.201:8017'; 
// export const proApiUrl = 'http://192.168.110.48:8017'; 
// export const proApiUrl = 'http://172.16.3.165:8209'; 
export function InterceptText (text) {
    return text.substring(0, 3) + '****' + text.substring(17)
  }
/**
   * 手机号中间四位为*
   */
export function InterceptPhone (phone) {
    return phone.substring(0, 3) + '****' + phone.substring(7)
  }
export function currentUrlToParams(key = null) {
    let paramsUrl = (window.location.href).split('?');
    if (paramsUrl.length < 2) return key ? null : {};
    let paramsArr = paramsUrl[1].split('&');
    let paramsData = {}
    paramsArr.forEach(r => {
        let data = r.split('=')
        paramsData[data[0]] = data[1]
    })
    if (key) return paramsData.hasOwnProperty(key) ? paramsData[key] : null;
    return paramsData;
}

export function clone(obj) {
    let strData = JSON.stringify(obj)
    return JSON.parse(strData);
}

export function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
};

function padLeftZero(str) {
    return ('00' + str).substr(str.length);
}

export function numberFormat(number, decimals, dec_point, thousands_sep) {
    /*
     * 参数说明：
     * number：要格式化的数字
     * decimals：保留几位小数
     * dec_point：小数点符号
     * thousands_sep：千分位符号
     * */
    number = (number + '').replace(/[^0-9+-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.ceil(n * k) / k;
        };

    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    var re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
    }

    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}


//时间戳转换方法    date:时间戳数字
export function format_ymd(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    //var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    // + ss
    return YY + MM + DD;
}


//时间戳转换方法    date:时间戳数字
export function format_datestr(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    //var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    // + ss
    return YY + MM + DD + " " + hh + mm;
}
//时间戳转换方法    date:时间戳数字
export function time_h_m(date) {
    var date = new Date(date);
    // var YY = date.getFullYear() + '-';
    // var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    // var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
    return hh + mm;
}


//时间戳转换方法    date:时间戳数字
export function format_datestrss(date) {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';;
    var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    // + ss
    return MM + DD + " " + hh + mm + ss;
}
//时间戳转换方法    date:时间戳数字
export function get_m_s(date) {
    var date = new Date(date-new Date().getTime());
    var mm =  date.getMinutes()
    var ss = date.getSeconds()
    return [mm,ss]
}
// 计算两个时间差 dateBegin 开始时间
export function timeFn(dateBegin) {
    //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
    var dateEnd = new Date(); //获取当前时间
    var dateDiff = dateBegin - dateEnd.getTime(); //时间差的毫秒数
    if (dateDiff <= 0) {
        return 0;
    }
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000)) //计算出小时数
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000)) //计算相差分钟数
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)

    var leave4 = leave3 % (60 * 1000) //计算分钟数后剩余的毫秒数
    var minseconds = Math.round(leave4 / 1000)
    dayDiff = dayDiff == 0 ? '' : dayDiff + "天 "
    hours = hours == 0 ? '' : hours + "时 "
    minutes = minutes == 0 ? '' : minutes + "分"
    var timeFn = dayDiff + hours + minutes; //+seconds+" 秒"+minseconds+"毫秒";
    return timeFn;
}

// 计算两个时间差 dateBegin 开始时间
export function timetwo(dateend) {
    //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
    var dateEnd = new Date(); //获取当前时间
    var dateDiff = dateEnd.getTime() - dateend; //时间差的毫秒数
    if (dateDiff <= 0) {
        return '0';
    }
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000)) //计算出小时数
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000)) //计算相差分钟数
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)

    var leave4 = leave3 % (60 * 1000) //计算分钟数后剩余的毫秒数
    var minseconds = Math.round(leave4 / 1000)
    dayDiff = dayDiff == 0 ? '' : dayDiff + "天 "
    hours = hours == 0 ? '' : hours + "时 "
    minutes = minutes == 0 ? '' : minutes + "分"
    var timeFn = dayDiff + hours + minutes; //+seconds+" 秒"+minseconds+"毫秒";
    return timeFn;
}


// 计算两个时间差 dateBegin 开始时间
export function time_cz(start_time, end_time) {
    var dateDiff = end_time - start_time; //时间差的毫秒数
    if (dateDiff <= 0) {
        return '0';
    }
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000)) //计算出小时数
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000)) //计算相差分钟数
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)

    var leave4 = leave3 % (60 * 1000) //计算分钟数后剩余的毫秒数
    var minseconds = Math.round(leave4 / 1000)

    dayDiff = dayDiff == 0 ? '' : dayDiff + "天 "
    hours = hours == 0 ? '' : hours + "时 "
    minutes = minutes == 0 ? '' : minutes + "分 "

    // seconds = seconds == 0 ? '' : seconds+"秒 "
    // minseconds = minseconds = 0 ? '': minseconds+'毫秒'

    var timeFn = dayDiff + hours + minutes; //+seconds+" 秒"+minseconds+"毫秒";

    if (timeFn.length == 0) {
        timeFn = '0分'
    }
    console.log('timeFn', timeFn)
    return timeFn;
}


function formatJson(filterVal, jsonData) {
    return jsonData.map((v) => filterVal.map((j) => v[j]));
}

var voiceData = {};
// socket 返回消息处理
export function handle_socket_msg(socket_data) {
    let obj = {
        type: '',
        html: "",
        ableShow: false,
        title: "",
        content: '',
    };
    console.log(socket_data,'socket_data')
    // 新订单提醒
    if (socket_data.type == "NewJdOrder") {
        if (getLocalStorage('new_order_no-v2') === 'true') {
            // var audio = new Audio();
            // audio.src = "https://static.fxzb.vip/voice/new_order_tip.mp3";
            // audio.play();
            if (!voiceData[socket_data.content]) {
                voiceData[socket_data.content] = true;
                console.log(88888)
                var audio = new Audio();
                audio.src = "https://static.fxzb.vip/voice/new_order_tip.mp3";
                audio.play();
            }
        }
        // 设置缓存
        if (socket_data.content == 0) {
            obj.ableShow = false;
            return;
        }
        obj.ableShow = getLocalStorage('new_order_no_notify_msg-v2') === 'true';
        obj.title = "新订单提醒";
        obj.html =
            "<strong>收到1条新订单</strong><a href='javascript:;' style='color:#409eff;margin-left:10px' >查看</a>";
    }

    // 我的订单数量【待出单】
    if (socket_data.type == "TicketerOrderCount") {
        // 设置缓存
        setLocalStorage("pushOrderNum", socket_data.content);
        // 不提示
        obj.ableShow = false;

    }
    // 接单大厅数量【待竞价】
    if (socket_data.type == "JdOrderCount") {
        // 设置缓存
        setLocalStorage("bidOrderNum", socket_data.content);
        // 不提示
        obj.ableShow = false;
    }

    // 竞价订单数量【竞价中】
    if (socket_data.type == "BidingOrderCount") {
        // 设置缓存
        setLocalStorage("playerOrderNum", socket_data.content);
        // 不提示
        obj.ableShow = false;
    }
    // 出单超时提醒
    if (socket_data.type == "TicketerOrderTimeout") {
        if (getLocalStorage('over_time_order') === 'true') {
            var audio = new Audio();
            audio.src = "https://static.fxzb.vip/voice/over_time_order.mp3";
            audio.play();
        }
        obj.ableShow = true;
        obj.title = "超时提醒";
        obj.html =
            "<strong>您有一条待出单订单已超时，请及时出单</strong><a href='javascript:;' style='color:#409eff;margin-left:10px'>去出单</a>";
    }
    obj.type = socket_data.type;
    // 返回内容
    obj.content = socket_data.content;
    return obj;

}

// 处理精度问题
export function signFigures(num, rank = 6) {
    if (!num) return (0);
    const sign = num / Math.abs(num);
    const number = num * sign;
    const temp = rank - 1 - Math.floor(Math.log10(number));
    let ans;
    if (temp > 0) {
        ans = parseFloat(number.toFixed(temp));
    } else if (temp < 0) {
        ans = Math.round(number / Math.pow(10, temp)) * temp;
    } else {
        ans = Math.round(number);
    }
    return (ans * sign);
}

var money_regular = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/; //正数（包括小数)
// 验证金额（大于0 ）
export function check_money(money,type) {
    if(type == 'LessMaxPrice' && (!money_regular.test(money) || money < 0)){
        return false;
    }
    if (type != 'LessMaxPrice' && (!money_regular.test(money) || money <= 0)) {
        return false;
    }
    return true;
}

// 验证金额（大于等于0 ）
export function check_money_no_zero(money) {
    if (!money_regular.test(money) || money < 0) {
        return false;
    }
    return true;
}